/* ====================================
# マウスホバーで画像切り替え（768px以上のみ）
==================================== */
export const imageSwitcher = () => {
  const plantItems = document.querySelectorAll('.p-top-business-field__item');
  const plantImages = document.querySelectorAll('.p-top-business-field__image');

  if (plantItems.length === 0 || plantImages.length === 0) return;

  const mediaQuery = window.matchMedia('(min-width: 768px)');
  let isListenersActive = false;

  // イベントハンドラー関数を定義
  const createMouseEnterHandler = (item) => () => {
    const linkElement = item.querySelector('.p-top-business-field__link');
    const targetImage = linkElement ? linkElement.getAttribute('data-image') : null;

    // 全ての画像からis-activeを削除
    plantImages.forEach((img) => {
      img.classList.remove('is-active');
    });

    // 対応する画像にis-activeを追加
    if (targetImage) {
      const activeImage = document.querySelector(`[data-target="${targetImage}"]`);
      if (activeImage) {
        activeImage.classList.add('is-active');
      }
    }
  };

  const createMouseLeaveHandler = () => () => {
    // マウスが離れた時は最初の画像（switch_img01）をアクティブにする
    plantImages.forEach((img) => {
      img.classList.remove('is-active');
    });

    const firstImage = document.querySelector('[data-target="switch_img01"]');
    if (firstImage) {
      firstImage.classList.add('is-active');
    }
  };

  // イベントリスナーを追加/削除する関数
  const toggleEventListeners = () => {
    if (mediaQuery.matches && !isListenersActive) {
      // 768px以上でイベントリスナーを追加
      plantItems.forEach((item) => {
        const mouseEnterHandler = createMouseEnterHandler(item);
        const mouseLeaveHandler = createMouseLeaveHandler();

        item.addEventListener('mouseenter', mouseEnterHandler);
        item.addEventListener('mouseleave', mouseLeaveHandler);

        // 削除用にハンドラーを保存
        item._mouseEnterHandler = mouseEnterHandler;
        item._mouseLeaveHandler = mouseLeaveHandler;
      });
      isListenersActive = true;
    } else if (!mediaQuery.matches && isListenersActive) {
      // 768px未満でイベントリスナーを削除
      plantItems.forEach((item) => {
        if (item._mouseEnterHandler) {
          item.removeEventListener('mouseenter', item._mouseEnterHandler);
          item.removeEventListener('mouseleave', item._mouseLeaveHandler);
          delete item._mouseEnterHandler;
          delete item._mouseLeaveHandler;
        }
      });
      isListenersActive = false;
    }
  };

  // 初回実行
  toggleEventListeners();

  // ウィンドウサイズ変更時に再評価
  mediaQuery.addEventListener('change', toggleEventListeners);
};